// import { ApiKeysCard } from '@components/Settings/ApiKeysCard';
import ColorBlindModeSelectorCard from '@components/Settings/ColorBlindModeCard';
import DefaultTeamCard from '@components/Settings/DefaultTeamCard';
import LanguageCard from '@components/Settings/LanguageCard';
import PasswordChangeCard from '@components/Settings/PasswordChangeCard';
import VersionCard from '@components/Settings/VersionCard';
import ViewerEnvironmentCard from '@components/Settings/ViewerEnvironmentCard';
import Header from '@components/Shared/Layout/Header';
import { Box } from '@mui/material';
import { useAppSelector } from '@store/hooks';

const SettingsPage = () => {
  // An account that only signs in through the identity provider has no password to change.
  const hasPassword = useAppSelector((state) => state.auth.user?.hasPassword) !== false;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
      <Header />
      <ColorBlindModeSelectorCard />
      <ViewerEnvironmentCard />
      <LanguageCard />
      <DefaultTeamCard />
      {hasPassword && <PasswordChangeCard />}
      {/* <ApiKeysCard /> */}
      <VersionCard />
    </Box >
  );
};

export default SettingsPage;
